<mat-card class="onboarding-banner" style="min-height: 180px">
    <ng-container *ngIf="(onboardingChecklist$ | async) as checklist">
        <ng-container *ngIf="isStartingMode$ | async">
            <h3>Let's get started!</h3>
            <div>We need a little more information to set up your account. If you want to view a sample client dashboard, click the icon next to the client name.</div>
        </ng-container>
        <ng-container *ngIf="isFinishMode$ | async">
            <h3>Let’s finish up!</h3>
            <div>View a sample client dashboard by clicking on the icon next to the client name. You can add clients yourself through a bulk CSV upload and with the “add client” button, or connect with our team to get client upload support at support@realfinity.io. Sample clients will be hidden once you add your clients.</div>
        </ng-container>

        <div class="Vert-15"></div>
        <div class="row">


            <!--Complete your profile-->
            <div class="col-lg-6 col-sm-12">
                <button class="btn onboarding" (click)="setupProfile()">
                    <div class="float-left"><mat-checkbox [disabled]="true" [checked]="checklist.hasCompleteAgentProfile"></mat-checkbox></div>
                    <div class="float-left">Complete your profile</div>
                </button>
            </div>

            <!--Complete company profile-->
            <div class="col-lg-6 col-sm-12" *ngIf="lgvUserSvc.IsAnyAdmin$ | async">
                <button class="btn onboarding" (click)="setupCompany()">
                    <div class="float-left"><mat-checkbox [disabled]="true" [(ngModel)]="checklist.hasCompleteCompanyProfile"></mat-checkbox></div>
                    <div class="float-left">Complete company profile</div>
                </button>
            </div>

            <ng-container *ngIf="isFinishMode$ | async">

                <!--Complete company profile-->
                <div class="col-lg-6 col-sm-12">
                    <button class="btn onboarding" routerLink="/admin/data-import">
                        <div class="float-left"><mat-checkbox [disabled]="true" [ngModel]="lgvApiSvc.HasRealClient$ | async"></mat-checkbox></div>
                        <div class="float-left">Add Clients</div>
                    </button>
                </div>

                <!--Set up email authorization-->
                <div class="col-lg-6 col-sm-12">
                    <button class="btn onboarding" (click)="setupEmail(checklist.hasSendEmailAsPermission, checklist?.hasCompleteCompanyProfile)">
                        <div class="float-left"><mat-checkbox [disabled]="true" [(ngModel)]="checklist.hasSendEmailAsPermission || isEmailSetupCompleted"></mat-checkbox></div>
                        <div class="float-left">Set up and launch client emails</div>
                    </button>
                </div>

            </ng-container>

        </div>

    </ng-container>
</mat-card>
